import { formatDistanceToNow, parseISO } from "date-fns";

import styles from "./TrustpilotReviews.module.css";
import TrustpilotStars from "./TrustpilotStars";
import { useTrustpilotLatestReviewsQuery } from "./api/useTrustpilotReviewsQuery";

export const relativeDate = (date: string): string =>
  formatDistanceToNow(parseISO(date), {
    addSuffix: true,
  });

function TrustpilotReviews() {
  const { reviews, isLoadingReviews, reviewsError } =
    useTrustpilotLatestReviewsQuery();

  if (isLoadingReviews || reviewsError || reviews.length === 0) {
    return null;
  }

  return (
    <div className={styles.widgetReviewsGrid}>
      <div className={styles.widgetReviewsFilterLabel}>
        Showing our latest reviews
      </div>
      <div className={styles.wrapperReviews}>
        <ul className={styles.widgetReviewList}>
          {reviews.slice(0, 4).map((review) => (
            <li key={review.id} className={styles.widgetReview}>
              <div className={styles.topRow}>
                <TrustpilotStars rating={review.stars} />
                <span className={styles.date}>
                  {relativeDate(review.createdAt)}
                </span>
              </div>
              <a
                className={styles.widgetReviewLink}
                href={`https://www.trustpilot.com/reviews/${review.id}`}
                target="_blank"
                rel="nofollow noreferrer"
              >
                <div className={styles.widgetReviewContent}>
                  <h3 className={styles.header}>{review.title}</h3>

                  <p className={styles.text}>{review.text}</p>

                  <p className={styles.userInfo}>{review.consumerName}</p>
                </div>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default TrustpilotReviews;
export { TrustpilotReviews };
